import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification, showSuccessNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useFineAttachmentsApi } from "../../http/fineAttachments/api";
import { FineAttachment } from "../../http/fineAttachments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteFineAttachmentDialogProps = {
  fineAttachment: FineAttachment;
  onClose: () => void;
};

const DeleteFineAttachmentDialog: FC<DeleteFineAttachmentDialogProps> = ({ fineAttachment, onClose }) => {
  const i18n = useI18n();
  const fineAttachmentsApi = useFineAttachmentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            fineAttachmentsApi
              .deleteFineAttachment(fineAttachment.id, fineAttachment.fine.id)
              .then(() => {
                onClose();
                dispatch(showSuccessNotification(i18n.t));
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteFineAttachmentDialog;
